module.exports = __webpack_public_path__ + "fonts/SuisseIntl-SemiBold.edb2568.woff2";